import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Popup } from '@progress/kendo-react-popup';
import { GridSelectionHLPure, SearchBarHLPure, Traslates, FormDatePicker, DropDownBtnHLPure, ButtonHLPure, SimpleLoading } from "../../pures";
import { ArrowBtnMobile } from "../../../assets/logos/icons";
import { NIL as NIL_UUID } from 'uuid';
import moment from "moment";
import "./digital-contract-home.css";

const DigitalContractHomeView = (props) => {
    let {
        t,
        history,
        isLoadingView,
        contracts,
        companies,
        questionnaires,
        handleSearchContracts,
        changeRoute,
        dataSearch,
        setDataSearch
    } = props

    const is8960 = useMediaQuery("(max-width:960px)");
    const is820 = useMediaQuery("(max-width:1180px)");
    const showNegotiation = useMediaQuery("(max-width: 700px)")

    const anchor = useRef();

    const headerColumnOne = (props) => {
        return <span className="digitalContractHomeView-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="digitalContractHomeView-header-cell-two">{props.title}</span>;
    };


    const headerColumnThree = (props) => {
        return <span className="digitalContractHomeView-header-cell-three">{props.title}</span>;
    };

    const headerColumnFour = (props) => {
        return <span className="digitalContractHomeView-header-cell-four">{props.title}</span>;
    }

    const cellColumnOne = (props) => {
        return (
            <td className='digitalContractHomeView-cell-one'>
                <span className="gridHLPure-userName">
                    {props.dataItem.name}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='digitalContractHomeView-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.typeContract}
                </span>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td className='digitalContractHomeView-cell-three'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.dateShow}
                </span>
            </td>
        );
    };
    const cellColumnFour = (props) => {
        return (
            <td className="digitalContractHomeView-cell-four">
                <div className="digitalContractHomeView-btns-actions">
                    <div className={"cellActions-containerBtnsDetails"}>
                        <button
                            className="cellActions-btn"
                            onClick={() => handleChangePage(props.dataItem)}
                        >
                            <p className="cellActions-textBotton">{t("digitalContractHomeView.btn.detail")}</p>
                        </button>
                    </div>
                    {
                        (props.dataItem.workflowStatusCurrent === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620) && !showNegotiation) && (
                            <div className={"cellActions-containerBtnsDetails"}>
                                <button
                                    className="cellActions-btn"
                                    onClick={() => sendToConsultNegotiation(props.dataItem)}
                                >
                                    <p className="cellActions-textBotton">{t("digitalContractHomeView.btn.consult.negotiation")}</p>
                                </button>
                            </div>
                        )
                    }
                </div>
                <div
                    className="cellActions-mobileExpanded"
                    onClick={() => handleChangePage(props.dataItem)}
                >
                    <img
                        className="cellActions-icon-arrow"
                        alt={"cellActions-arrow"}
                        src={ArrowBtnMobile}
                    />
                </div>
            </td>
        );
    };

    const [showPopup, setShowPoup] = useState(false)
    const [startDateSearch, setStartDateSeacrh] = useState('')
    const [endDateSearch, setEndDateSeacrh] = useState('')
    const [companyId, setCompanyId] = useState('1')
    const [questionnaireId, setQuestionnaireId] = useState(NIL_UUID)
    const [contractsShow, setContractsShow] = useState([])
    const [allContracts, setAllContract] = useState([])
    const [searchValue, setSearchValue] = useState([])



    useEffect(() => {
        if (!dataSearch) return
        let { companyId, questionnaireId, startdate, endDate } = dataSearch

        startdate = new Date(startdate)
        endDate = new Date(endDate)

        setShowPoup(false)
        if (!startdate && endDate) {
            let today = new Date()
            let year = today.getFullYear();
            let completeDate = `${year}-01-01`
            startdate = new Date(completeDate)
        }

        if (startdate && !endDate) {
            endDate = new Date()
        }

        if (!startdate && !endDate) {
            let contractsCopy = allContracts
            let newContarcts = []
            if (companyId === '1' && questionnaireId === NIL_UUID) {
                newContarcts = contractsCopy
            } else if (companyId === '1') {
                newContarcts = contractsCopy.filter((contract) => contract.questionnaire.id === questionnaireId)
            } else if (questionnaireId === NIL_UUID) {
                newContarcts = contractsCopy.filter((contract) => contract.questionnaire.companyId === companyId)
            } else {
                newContarcts = contractsCopy.filter((contract) => {
                    return (
                        contract.questionnaire.companyId === companyId &&
                        contract.questionnaire.id === questionnaireId
                    )
                })
            }

            setQuestionnaireId(questionnaireId)
            setCompanyId(companyId)
            setEndDateSeacrh(endDate)
            setStartDateSeacrh(startdate)
            setContractsShow(newContarcts)
            return
        }

        setQuestionnaireId(questionnaireId)
        setCompanyId(companyId)
        setEndDateSeacrh(endDate)
        setStartDateSeacrh(startdate)
        handleSearchContracts(companyId, questionnaireId, startdate, endDate, setShowPoup)
    }, [dataSearch])

    useEffect(() => {
        if (!contracts) return
        setContractsShow(contracts)
        setAllContract(contracts)

        if (!startDateSearch && !endDateSearch && !dataSearch) {
            let today = new Date()
            let startDate = moment(today).add(-60, 'days')
            startDate = new Date(startDate)
            setStartDateSeacrh(startDate)
            setEndDateSeacrh(today)
        }
    }, [contracts])

    useEffect(() => {
        let contractasCopy = allContracts
        let newContracts = contractasCopy.filter(contract => contract.name.toLowerCase().includes(searchValue.toLowerCase()))
        setContractsShow(newContracts)
    }, [searchValue])

    const handlePopup = () => {
        setShowPoup(!showPopup)
    }

    const onChangeInputs = (e, setValue) => {
        let value = e.target.value
        setValue(value)
    }

    const handleSearch = () => {
        let startdate = startDateSearch
        let endDate = endDateSearch
        setShowPoup(false)
        if (!startdate && endDate) {
            let today = new Date()
            let year = today.getFullYear();
            let completeDate = `${year}-01-01`
            startdate = new Date(completeDate)
        }

        if (startdate && !endDate) {
            endDate = new Date()
        }

        if (!startdate && !endDate) {
            let contractsCopy = allContracts
            let newContarcts = []
            if (companyId === '1' && questionnaireId === NIL_UUID) {
                newContarcts = contractsCopy
            } else if (companyId === '1') {
                newContarcts = contractsCopy.filter((contract) => contract.questionnaire.id === questionnaireId)
            } else if (questionnaireId === NIL_UUID) {
                newContarcts = contractsCopy.filter((contract) => contract.questionnaire.companyId === companyId)
            } else {
                newContarcts = contractsCopy.filter((contract) => {
                    return (
                        contract.questionnaire.companyId === companyId &&
                        contract.questionnaire.id === questionnaireId
                    )
                })
            }

            let dataSearch = {
                companyId,
                questionnaireId,
                startdate,
                endDate
            }
            setDataSearch(dataSearch)
            setContractsShow(newContarcts)
            return
        }


        let dataSearch = {
            companyId,
            questionnaireId,
            startdate,
            endDate
        }

        setDataSearch(dataSearch)
        handleSearchContracts(companyId, questionnaireId, startdate, endDate, setShowPoup)
    }

    const handleChangePage = (dataItem) => {
        let includeState = true
        if (dataItem.url === 'detail-contract') {
            let hash = `${dataItem.id}`

            changeRoute(dataItem.url, includeState, null, hash)
        } else {
            history.push(dataItem.url)
        }
    }

    const sendToConsultNegotiation = async (clientContract) => {
        history.push(`/consult-negotiation/${clientContract.id}/${clientContract.workflowExecutionId}`);
    }

    if (isLoadingView) return <SimpleLoading />

    return (
        <div className="digitalContractHomeView-container">
            <div className='digitalContractHomeView-search-container'>
                <div className='digitalContractHomeView-search'>
                    <SearchBarHLPure
                        placeholder={t("digitalContractHomeView.search.placeholder")}
                        searchValue={searchValue}
                        onSearchChange={(e) => onChangeInputs(e, setSearchValue)}
                    />
                </div>
                <button className="digitalContractHomeView-btn-open-popup" ref={anchor} onClick={() => handlePopup()}>
                    <span class="k-icon k-font-icon k-i-arrow-overflow-down"></span>
                </button>
                <Popup
                    anchor={anchor.current}
                    show={showPopup}
                    className={"popup-container-class"}
                    anchorAlign={{ horizontal: "right", vertical: "bottom", }}
                    popupAlign={{ horizontal: "right", vertical: "top", }}
                >
                    <div className="digitalContractHomeView-popup-container">
                        <div className="digitalContractHomeView-popup-inputs-container">
                            <div className="digitalContractHomeView-dates-container">
                                <div className="digitalContractHomeView-start-date-container">
                                    <span className="digitalContractHomeView-start-date">{t("digitalContractHomeView.start.date")}</span>
                                    <Traslates>
                                        <FormDatePicker
                                            id={"date"}
                                            name={"date"}
                                            format="dd-MMM-yyyy"
                                            onChange={(e) => onChangeInputs(e, setStartDateSeacrh)}
                                            value={startDateSearch}
                                        />
                                    </Traslates>
                                </div>
                                <div className="digitalContractHomeView-start-date-container">
                                    <span className="digitalContractHomeView-start-date">{t("digitalContractHomeView.end.date")}</span>
                                    <Traslates>
                                        <FormDatePicker
                                            id={"date"}
                                            name={"date"}
                                            format="dd-MMM-yyyy"
                                            onChange={(e) => onChangeInputs(e, setEndDateSeacrh)}
                                            value={endDateSearch}
                                        />
                                    </Traslates>
                                </div>
                            </div>
                            <DropDownBtnHLPure
                                labelDropDown={t("digitalContractHomeView.company")}
                                optionsDropDown={companies}
                                optionsValue={companyId}
                                valueItem={"id"}
                                nameOption={"companyName"}
                                onDropDownChange={(e) => onChangeInputs(e, setCompanyId)}
                            />
                            <DropDownBtnHLPure
                                labelDropDown={t("digitalContractHomeView.contract.type")}
                                optionsDropDown={questionnaires}
                                optionsValue={questionnaireId}
                                valueItem={"id"}
                                nameOption={"name"}
                                onDropDownChange={(e) => onChangeInputs(e, setQuestionnaireId)}
                            />
                        </div>
                        <div className="digitalContractHomeView-search-btn">
                            <ButtonHLPure
                                nameBtn={t("digitalContractHomeView.btn.search")}
                                primary={true}
                                onClickBtn={() => handleSearch()}
                            />
                        </div>
                    </div>
                </Popup>
            </div>

            <Grid item>
                <GridSelectionHLPure
                    dataGrid={contractsShow}
                    skip={0}
                    take={6}
                    pageable={true}
                    styleGeneral={true}
                    styleGeneralClass={"digitalContractHomeView-general-grid"}
                    columnTwo={(is820) ? false : true}
                    columnThree={(is8960) ? false : true}
                    columnFour={true}
                    titleRow1={t("digitalContractHomeView.title.1")}
                    titleRow2={t("digitalContractHomeView.title.2")}
                    titleRow3={t("digitalContractHomeView.title.date")}
                    titleRow4={t("digitalContractHomeView.title.3")}
                    headerColumnOne={headerColumnOne}
                    cellColumnOne={cellColumnOne}
                    headerColumnTwo={headerColumnTwo}
                    cellColumnTwo={cellColumnTwo}
                    headerColumnTwoClass={"digitalContractHomeView-header-cell-two-styles"}
                    headerColumnThree={headerColumnThree}
                    cellColumnThree={cellColumnThree}
                    headerColumnThreeClass={"digitalContractHomeView-header-cell-three-styles"}
                    headerColumnFour={headerColumnFour}
                    cellColumnFour={cellColumnFour}
                    headerColumnFourClass={"digitalContractHomeView-header-cell-four-styles"}
                    styleGrid={{ height: 'auto' }}
                />
            </Grid>
            <div className="digitalContractHomeView-btns-container">
                <ButtonHLPure
                    nameBtn={t("helpDesk.digitalContract.goBack.btn")}
                    onClickBtn={() => history.push("/help-desk")}
                />
            </div>
        </div>
    )
}

export { DigitalContractHomeView as default }